import { TextOverflowBox } from '@sternum/web/components/TextOverflowBox';

import { IconContainer } from '../IconContainer';
import { MenuTooltip } from '../MenuTooltip';

import { MenuItemLinkProps } from './MenuItemLink.types';

import { LeftBarDecoration, MenuItemLinkStyled } from './MenuItemLink.styles';

export function MenuItemLink({
  to = '#',
  icon,
  children,
  variant = 'expanded',
  disabled,
  tooltipThemeMode,
  ...props
}: MenuItemLinkProps) {
  const toProp = disabled ? '#' : to;

  if (variant === 'collapsed') {
    const renderedChildren =
      typeof children === 'function'
        ? children({ isActive: false, isPending: false, isTransitioning: false })
        : children;

    return (
      <MenuTooltip themeMode={tooltipThemeMode} title={renderedChildren} position="right" tooltipOffsetX={7}>
        <MenuItemLinkStyled
          role="menuitem"
          aria-label="Menu item - link"
          to={toProp}
          variant={variant}
          disabled={disabled}
          {...props}
        >
          <LeftBarDecoration />
          {icon && <IconContainer>{icon}</IconContainer>}
        </MenuItemLinkStyled>
      </MenuTooltip>
    );
  }

  return (
    <MenuItemLinkStyled
      role="menuitem"
      aria-label="Menu item - link"
      to={toProp}
      variant={variant}
      disabled={disabled}
      {...props}
    >
      {({ isActive, isPending, isTransitioning }) => {
        const renderedChildren =
          typeof children === 'function' ? children({ isActive, isPending, isTransitioning }) : children;

        return (
          <>
            <LeftBarDecoration />
            {icon && <IconContainer>{icon}</IconContainer>}
            <TextOverflowBox>{renderedChildren}</TextOverflowBox>
          </>
        );
      }}
    </MenuItemLinkStyled>
  );
}
